var _defs, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoZuercherKantonalbank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_zurcher_kantonalbank",
    "data-name": "logo zurcher kantonalbank",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.813,
    height: 35,
    viewBox: "0 0 149.813 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1811",
    "data-name": "Rectangle 1811",
    width: 149.813,
    height: 35,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15158",
    "data-name": "Path 15158",
    d: "M1.312,1.312H33.687V33.687H1.312ZM0,35H35V0H0Z",
    fill: "#003cb4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15159",
    "data-name": "Path 15159",
    d: "M41.6,9.364H28.475L20.6,22.489l7.875,13.125H41.6L33.725,22.489Z",
    transform: "translate(-10.975 -4.989)",
    fill: "#003cb4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M96.9,19.634l6.044-8.681H97.1V9.484h7.763v1.5l-6.025,8.681h6.125v1.469H96.9Z",
    transform: "translate(-51.624 -5.053)",
    fill: "#003cb4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21703",
    "data-name": "Group 21703",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21702",
    "data-name": "Group 21702",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15161",
    "data-name": "Path 15161",
    d: "M125.333,21.32h-1.519V19.97a3.063,3.063,0,0,1-2.788,1.55c-2.206,0-3.194-1.369-3.194-3.656V12.807H119.4v4.407c0,1.987.437,2.956,1.806,3.038,1.787,0,2.588-1.432,2.588-3.507V12.807h1.569ZM119.427,9.832H121v1.656h-1.569Zm2.731,0h1.575v1.656h-1.581Z",
    transform: "translate(-62.777 -5.238)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15162",
    "data-name": "Path 15162",
    d: "M138.888,15.971h1.469V17.29h.038a2.581,2.581,0,0,1,2.218-1.519,4.726,4.726,0,0,1,1.038.113V17.29a2.3,2.3,0,0,0-.869-.15c-1.406,0-2.325,1.332-2.325,3.469v3.875h-1.569Z",
    transform: "translate(-73.994 -8.402)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15163",
    "data-name": "Path 15163",
    d: "M156.688,17.4a4.688,4.688,0,0,0-1.706-.363,2.917,2.917,0,0,0-2.738,3.187c0,1.519.819,3.187,2.838,3.187a3.26,3.26,0,0,0,1.688-.481l.119,1.4a4.819,4.819,0,0,1-1.975.35,4.307,4.307,0,0,1-4.34-4.272c0-.061,0-.123,0-.184a4.2,4.2,0,0,1,4.337-4.456,5.935,5.935,0,0,1,1.875.331Z",
    transform: "translate(-80.219 -8.402)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15164",
    "data-name": "Path 15164",
    d: "M167.206,7.625h1.569V12.85a3.126,3.126,0,0,1,2.807-1.419c2.206,0,3.194,1.369,3.194,3.657v5.056h-1.569V15.769c0-1.988-.437-2.957-1.806-3.038-1.788,0-2.588,1.431-2.588,3.506v3.937h-1.606Z",
    transform: "translate(-89.081 -4.062)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15165",
    "data-name": "Path 15165",
    d: "M194.266,24.134a6.471,6.471,0,0,1-2.688.55c-3.018,0-4.375-1.832-4.375-4.607,0-2.5,1.588-4.306,3.994-4.306,2.837,0,3.75,2.068,3.75,4.806h-6.075a2.788,2.788,0,0,0,2.75,2.825h.025a5,5,0,0,0,2.618-.85Zm-1.019-4.725a2.145,2.145,0,0,0-2.119-2.369,2.35,2.35,0,0,0-2.287,2.369Z",
    transform: "translate(-99.735 -8.402)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15166",
    "data-name": "Path 15166",
    d: "M207.51,15.971h1.468v1.319h.031a2.589,2.589,0,0,1,2.225-1.519,4.612,4.612,0,0,1,1.031.113v1.406a2.281,2.281,0,0,0-.869-.15c-1.4,0-2.318,1.332-2.318,3.469v3.875H207.51Z",
    transform: "translate(-110.553 -8.402)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15167",
    "data-name": "Path 15167",
    d: "M96.966,40.451h1.675v5.125l5-5.125h2.219l-5.475,5.512,5.906,6.144h-2.438l-5.188-5.712v5.712h-1.7Z",
    transform: "translate(-51.66 -21.551)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15168",
    "data-name": "Path 15168",
    d: "M119.312,47.537a5.42,5.42,0,0,1,2.806-.8c2.438,0,3.425,1.206,3.425,3.525v3.525a14.516,14.516,0,0,0,.063,1.669H124.13V54.35a3.154,3.154,0,0,1-2.637,1.306c-1.838,0-3.125-.8-3.125-2.656,0-2.137,2.338-2.806,3.957-2.806.625,0,1.056,0,1.675.038,0-1.469-.537-2.225-2.106-2.225a4.016,4.016,0,0,0-2.5.869Zm4.663,3.863c-.337,0-.669-.037-1.006-.037-.85,0-2.95.131-2.95,1.637a1.5,1.5,0,0,0,1.581,1.388,2.15,2.15,0,0,0,2.365-1.911,2.123,2.123,0,0,0,.01-.327Z",
    transform: "translate(-63.062 -24.9)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15169",
    "data-name": "Path 15169",
    d: "M138.571,46.942h1.519v1.35a3.07,3.07,0,0,1,2.788-1.556c2.206,0,3.194,1.369,3.194,3.656v5.063H144.5V51.079c0-1.987-.437-2.956-1.806-3.044-1.787,0-2.587,1.437-2.587,3.506v3.944H138.54Z",
    transform: "translate(-73.809 -24.898)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15170",
    "data-name": "Path 15170",
    d: "M162.8,45.619h-2.244v4.663a1.35,1.35,0,0,0,1.17,1.508,1.307,1.307,0,0,0,.148.01,1.943,1.943,0,0,0,1.069-.3v1.338a4.951,4.951,0,0,1-1.338.231c-1.619,0-2.619-.769-2.619-2.5v-5h-1.918V44.32h1.918V42.382l1.569-.5v2.5h2.25Z",
    transform: "translate(-83.679 -22.313)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15171",
    "data-name": "Path 15171",
    d: "M175.893,46.737a4.2,4.2,0,0,1,4.325,4.463,4.338,4.338,0,0,1-8.669.329q-.006-.165,0-.329a4.2,4.2,0,0,1,4.344-4.463m0,7.65c1.838,0,2.656-1.669,2.656-3.187,0-1.619-.987-3.194-2.656-3.194s-2.669,1.575-2.669,3.194c0,1.519.813,3.187,2.669,3.187",
    transform: "translate(-91.393 -24.9)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15172",
    "data-name": "Path 15172",
    d: "M193.825,46.942h1.519v1.35a3.07,3.07,0,0,1,2.788-1.556c2.206,0,3.188,1.369,3.188,3.656v5.063H199.75V51.079c0-1.987-.431-2.956-1.8-3.044-1.787,0-2.587,1.437-2.587,3.506v3.944h-1.538Z",
    transform: "translate(-103.262 -24.898)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15173",
    "data-name": "Path 15173",
    d: "M214.626,47.537a5.428,5.428,0,0,1,2.806-.8c2.437,0,3.425,1.206,3.425,3.525v3.525a14.42,14.42,0,0,0,.063,1.669h-1.462V54.35h-.032a3.153,3.153,0,0,1-2.638,1.306c-1.837,0-3.124-.8-3.124-2.656,0-2.137,2.343-2.806,3.962-2.806.625,0,1.05,0,1.669.038,0-1.469-.537-2.225-2.106-2.225a4.013,4.013,0,0,0-2.5.869Zm4.663,3.863c-.337,0-.669-.037-1.006-.037-.85,0-2.95.131-2.95,1.637a1.5,1.5,0,0,0,1.581,1.388,2.15,2.15,0,0,0,2.365-1.911,2.121,2.121,0,0,0,.01-.327Z",
    transform: "translate(-113.831 -24.9)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1810",
    "data-name": "Rectangle 1810",
    width: 1.569,
    height: 12.5,
    transform: "translate(109.513 18.031)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15174",
    "data-name": "Path 15174",
    d: "M243.1,38.591h1.569v5.175h.037a3.038,3.038,0,0,1,2.819-1.369c2.5,0,3.675,2.025,3.675,4.313s-1.087,4.606-3.656,4.606a3.407,3.407,0,0,1-2.906-1.382H244.6v1.206h-1.5Zm4.094,5.094c-1.706,0-2.5,1.625-2.5,3.206,0,1.419.738,3.175,2.5,3.175s2.388-1.875,2.35-3.225c.019-1.55-.656-3.156-2.35-3.156",
    transform: "translate(-129.516 -20.56)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15175",
    "data-name": "Path 15175",
    d: "M263.9,47.537a5.4,5.4,0,0,1,2.806-.8c2.437,0,3.419,1.206,3.419,3.525v3.525a13.636,13.636,0,0,0,.069,1.669h-1.469V54.35H268.7a3.168,3.168,0,0,1-2.644,1.306c-1.838,0-3.125-.8-3.125-2.656,0-2.137,2.338-2.806,3.956-2.806.625,0,1.05,0,1.669.038,0-1.469-.531-2.225-2.1-2.225a4.036,4.036,0,0,0-2.5.869Zm4.656,3.863c-.331,0-.669-.037-1-.037-.85,0-2.956.131-2.956,1.637a1.506,1.506,0,0,0,1.587,1.388,2.151,2.151,0,0,0,2.369-2.238Z",
    transform: "translate(-140.078 -24.9)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15176",
    "data-name": "Path 15176",
    d: "M283.234,46.941h1.518v1.35h.038a3.062,3.062,0,0,1,2.788-1.556c2.206,0,3.188,1.369,3.188,3.656v5.063H289.2V51.079c0-1.987-.431-2.956-1.806-3.044-1.781,0-2.581,1.437-2.581,3.506v3.944h-1.575Z",
    transform: "translate(-150.896 -24.898)",
    fill: "#003cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15177",
    "data-name": "Path 15177",
    d: "M304.288,38.591h1.575v7.463l3.425-3.45h2.138l-3.956,3.75,4.456,4.743H309.67l-3.806-4.375V51.1h-1.569Z",
    transform: "translate(-162.113 -20.56)",
    fill: "#003cb4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZuercherKantonalbank);
export default __webpack_public_path__ + "static/media/logo_zuercher_kantonalbank.0b8c6d956e02673f34fe4de5aab5fd4f.svg";
export { ForwardRef as ReactComponent };